'use strict';

bbw.model.ContestParticipant = ngtk.model.Item.extend({

    $q: undefined,

    $inject: ['modelFactory', 'rpcClient', '$q'],

    contestId: undefined,
    _forAdmin: false,

    construct: function(modelFactory, rpcClient, $q) {
        this._api = rpcClient;
        this._modelFactory = modelFactory;
        this.$q = $q;
        this._initialize();
    },

    forAdmin: function(isForAdmin) {
        this._forAdmin = angular.isUndefined(isForAdmin) ? true : !!isForAdmin;
        return this;
    },

    isPartial: function() {
        if (!this.get('id')) {
            return false;
        }
        return !this.get('is_submitted') && this.hasAnyPhotos();
    },

    hasAnyPhotos: function() {
        return ['photos', 'verificationPhotos'].reduce(function(result, key) {
            var data;
            return result || (angular.isArray(data = this.get(key)) && data.length);
        }.bind(this), false);
    },

    getContestId: function() {
        if (!this.contestId) {
            throw new Error("contest id is undefined");
        }
        return this.contestId;
    },

    canSubmit: function() {
        return ['photos', 'verificationPhotos'].reduce(function(result, key) {
            var data;
            return result && angular.isArray(data = this.get(key)) && data.length;
        }.bind(this), true);
    },

    approve: function() {
        return this._applyModeration('approve');
    },

    reject: function(reason) {
        return this._applyModeration('reject', reason);
    },

    _applyModeration: function(action, reason) {
        if (!this._forAdmin) {
            throw new Error("Admin only feature");
        }
        return this._api.post('admin/contests/participant-moderation', {
            contest_id: this.getContestId(),
            participant_user_id: this.get('user_id'),
            action: action,
            rejection_reason: reason
        }).execute();
    },

    deletePhoto: function(photoId, isVerification) {
        var method;
        if (this._forAdmin) {
            method = 'admin/contests/' + this.getContestId() + '/delete-photo';
        } else {
            method = 'contest/' + this.getContestId() + '/delete-photo';
        }
        return this._api
            .post(method, {photo_id: photoId, verification: isVerification, user_id: this.get('user_id')})
            .execute();
    },

    blurPhotoByAdmin: function(photoId, forceBlur) {
        if (angular.isUndefined(forceBlur)) {
            forceBlur = true;
        } else {
            forceBlur = !!forceBlur;
        }
        var method = 'admin/contests/' + this.getContestId() + '/blur-photo';
        return this._api
            .post(method, {photo_id: photoId, force_blur: forceBlur, user_id: this.get('user_id')})
            .execute();
    },

    reorderPhoto: function(photoId, orderIdx) {
        return this._api
            .post('contest/' + this.getContestId() + '/reorder-photo', {photo_id: photoId, order_idx: orderIdx})
            .execute();
    },

    submit: function() {
        if (!this.canSubmit()) {
            throw new Error("Cannot submit application: not enough photos");
        }
        return this._api.post('contest/' + this.getContestId() + '/submit-application').execute().then(function(response) {
            this._setFromApiResult(response.participant);
        }.bind(this));
    },

    delete: function() {
        return this._api.post('contest/' + this.getContestId() + '/delete-application').execute();
    },

    setContestId: function(id) {
        this.contestId = id;
        return this;
    },

    loadForCurrentUser: function(createIfMissing) {
        return this._loadFromApi(createIfMissing ? 'post' : 'get', 'contest/' + this.getContestId() + '/participant')
            .then(function(response) {
                this._setFromApiResult(response.participant);
            }.bind(this));
    },

    _extractIdFromItemData: function(itemData) {
        return itemData.id;
    }

});
